import { memo } from "react";

import SkeletonList from "@/components/organisms/SkeletonList";
import { Stack } from "@/components/atoms/Stack";

/**
 * LoadingSkeletonView displays a loading skeleton while similar players data is being fetched.
 * Accepts no props.
 */
const LoadingSkeletonView = () => (
  <Stack className="flex-1">
    <Stack className="flex-1 p-4">
      <SkeletonList type="player" />
    </Stack>
  </Stack>
);

LoadingSkeletonView.displayName = "LoadingSkeletonView";

export default memo(LoadingSkeletonView);
